import { defineComponent } from 'vue';
export default defineComponent({
  name: 'AddressDropdownMembers',
  inheritAttrs: false,
  props: {
    noShake: {
      type: Boolean,
      default: false
    },
    autocompleteResult: {
      type: Array
    },
    value: {
      type: String
    },
    // eslint-disable-next-line vue/require-prop-types
    inputClass: {
      required: false
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    },
    onSelectAddressHandler(address) {
      this.$emit('selectAddressHandler', address);
    },
    onFieldFocus() {
      this.$emit('focus');
    },
    onFieldChange() {
      this.$emit('keyup');
    },
    onFieldBlur() {
      // timeout prevents the case where you click on a suggestion, and onBlur fires and clears the results before onSelectAddressHandler fires
      // timeout isn't ideal, but not noticeable in practice
      window.setTimeout(() => {
        this.$emit('blur');
        this.$emit('update:autocompleteResult', []);
      }, 100);
    }
  }
});